// Bridge: isolates the cross-domain dependency on sales-tax upload modal.
// When this component is extracted to a standalone shared package, update this single import.
export { default as SalesTaxImportTransactionsModal } from '../../../sales-tax/transactions-tab/modal/transactions-upload-modal';
